import {APP_CLEAR, USER_SET_AGENT, REPORT_RES_SET_LIST, REPORT_RES_CLEAR_LIST, REPORT_RES_SET_INFO,
  REPORT_REFUNDS_SET_LIST, REPORT_REFUNDS_CLEAR_LIST, REPORT_REFUNDS_SET_INFO, 
  REPORT_SALES_SET_LIST, REPORT_SALES_CLEAR_LIST, REPORT_SALES_SET_INFO} from '../constants/actionTypes';

const initialState ={
  reservations: [],
  resFilter: null,
  resInfo: "Wybierz kryteria i wyszukaj rezerwacje",
  refunds: [],
  refundsFilter: null,
  refundsInfo: "Wybierz kryteria i wyszukaj zwroty",
  sales: [],
  salesFilter: null, 
  salesInfo: "Wybierz kryteria dla raportu"
};

const coursesReducer = (state = initialState, action) => {  
  switch (action.type) {    
    case REPORT_RES_SET_LIST:      
      return {
        ...state, 
        reservations: action.reservations,
        ticketUrlPath: action.ticketUrlPath,
        resFilter: action.filter,
        resInfo: ((action.reservations.length>0)?"":"Brak rezerwacji spełniających kryteria wyszukiwania")        
      }
    case REPORT_RES_CLEAR_LIST:
      return {
        ...state, 
        reservations: initialState.reservations,
        resInfo: initialState.reservations,
      }
    case REPORT_RES_SET_INFO:
      return {
        ...state,
        resInfo: action.infoText,
      }
    case REPORT_REFUNDS_SET_LIST:      
      return {
        ...state, 
        refunds: action.refunds,
        refundsFilter: action.filter,
        refundsInfo: ((action.refunds.length>0)?"":"Brak zwrotów spełniających kryteria wyszukiwania")        
      }
    case REPORT_REFUNDS_CLEAR_LIST:
      return {
        ...state, 
        refunds: initialState.refunds,
        refundsInfo: initialState.refundsInfo,
      }
      case REPORT_REFUNDS_SET_INFO:
      return {
        ...state,
        refundsInfo: action.infoText,
      }
    case REPORT_SALES_SET_LIST:      
      return {
        ...state, 
        sales: action.sales,        
        salesFilter: action.salesFilter,
        salesInfo: ((action.sales.length>0)?"":"Brak pozycji spełniających kryteria wyszukiwania")        
      }
    case REPORT_SALES_CLEAR_LIST:
      return {
        ...state, 
        sales: initialState.summary,
        salesInfo: initialState.salesInfo   
      }
    case REPORT_SALES_SET_INFO:
      return {
        ...state,
        salesInfo: action.infoText,
      }
    case USER_SET_AGENT:
    case APP_CLEAR:
      return {
          ...state, 
          ...initialState
        }
    default:
      return state;
   }
};
 
export default coursesReducer;


// WEBPACK FOOTER //
// ./src/reducers/reportReducer.js